<template>
<v-container fluid class="page-wrap">
    <v-row>
      <v-col cols="12" class="text-center">
          <header-vue/>
      </v-col>

      <v-col
        class="mb-5"
        md="12"
      >
            <v-card class="rounded-xl pa-2 pa-md-3" elevation="3">
                <v-card-title class="page-title-row">
                    <div>
                        <div class="text-overline accent--text font-weight-bold">{{ currentSession }} / {{ currentTerm }} TERM</div>
                        <div class="text-h6 font-weight-bold primary--text">Students</div>
                    </div>
                    <v-spacer></v-spacer>
                    <div class="d-flex flex-wrap stat-chip-row">
                        <div class="stat-chip">
                            <div class="stat-chip-value">{{records.length}}</div>
                            <div class="stat-chip-label">Total Records</div>
                        </div>
                        <div class="stat-chip stat-chip-success">
                            <div class="stat-chip-value">{{studentsWithClassesCount}}</div>
                            <div class="stat-chip-label">This Session</div>
                        </div>
                        <div class="stat-chip stat-chip-error">
                            <div class="stat-chip-value">{{records.length - studentsWithClassesCount}}</div>
                            <div class="stat-chip-label">Not Promoted / Alumni</div>
                        </div>
                    </div>
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <!-- Create /Update Form -->
                        <v-col cols="12">
                            <get-classes-record-axios-by-school :authToken="authToken" :school="school" @get_classes="getClasses"/>
                            <create-student-form :authToken="authToken" :school="school" :classes="classes" :editFormSignal="editFormSignal" :refreshRecordSignal="refreshRecordSignal" @get_students="getStudents" @get_students_count="getStudentsCount"/>

                            <promote-demote-students :classes="classes" :authToken="authToken" :school="school" @promoted="refreshPromotedStudents"/>
                        </v-col>
                        <!-- Records -->
                        <v-col cols="12">
                            <v-alert
                            v-if="records.length && studentsWithClassesCount < 1"
                                type="warning"
                                dense
                                border="left"
                                text
                                color="black"
                               >
                                We noticed that you have recently just switched to a NEW/ANOTHER Session. Don't worry, your students were not deleted. When you switch from OLD session to NEW Session on our software, your Student records are hidden because they are no longer in the old class. You DO NOT need to recreate them. To display them in their new class, You only need to click on the Promote/Demote button to move them to NEW CLASSES and they will re-appear on the list below
                            </v-alert>
                            <v-alert
                                type="info"
                                dense
                                border="left"
                                text
                                color="orange"
                                >
                                <marquee>
                                    <span v-for="(info,i) in infos" :key="i" class="black--text mr-5">
                                    {{info.content}} | &nbsp;
                                    </span>
                                </marquee>
                            </v-alert>
                            <info-loader-2 v-if="fetchingContent"/>
                            <v-row class="mb-1 mt-2" v-else>
                                <v-col cols="12" md="12">
                                    <v-card outlined class="rounded-lg">
                                        <v-card-title>
                                        <v-spacer></v-spacer>
                                        <v-text-field
                                            v-model="search"
                                            append-icon="mdi-magnify"
                                            label="Search"
                                            single-line
                                            hide-details
                                            outlined
                                            dense
                                            class="search-field"
                                        ></v-text-field>
                                        </v-card-title>

                                        <v-data-table
                                        :headers="headers"
                                        :items="studentsWithClasses"
                                        :search="search"
                                        group-by="current_class"
                                        class="elevation-0"
                                        :options="{
                                        itemsPerPage: 50
                                        }"
                                        :footer-props="{ 'items-per-page-options': [25, 50, 100, 200, -1] }"
                                        dense
                                        >

                                            <template v-slot:item.passport="{ item }">
                                                <span v-if="item.status ==='active'">
                                                    <img
                                                    :src="item.passport"
                                                    height="30"/>
                                                </span>
                                            </template>

                                            <template v-slot:item.fullname="{ item }">
                                                <span v-if="item.status ==='inactive'" style="color: dimgray;">
                                                    <em><del>{{ item.fullname }}</del></em>
                                                </span>
                                                <span v-else>
                                                    {{ item.fullname }}
                                                </span>
                                            </template>

                                            <template v-slot:item.gender_letter="{ item }">
                                                <v-chip
                                                    :color="getGenderColor(item.gender_letter)"
                                                    dense
                                                >
                                                    {{ item.gender_letter }}
                                                </v-chip>
                                            </template>

                                            <template v-slot:item.status="{ item }">
                                                <v-chip v-if="item.status ==='active'"
                                                    color="green"
                                                    dense
                                                    dark
                                                >
                                                    {{ item.status }}
                                                </v-chip>
                                                <span v-else>
                                                    {{ item.status }}
                                                </span>
                                            </template>

                                            <template v-slot:item.actions="{ item }">
                                                <v-btn @click="editFormSignal = item" fab light x-small class="mr-2" elevation="1">
                                                    <v-icon
                                                        small
                                                    >
                                                        mdi-pencil
                                                    </v-icon>
                                                </v-btn>
                                            </template>

                                        </v-data-table>
                                    </v-card>
                                </v-col>
                                <!-- archive -->
                            </v-row>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from 'axios';
import HeaderVue from '../../components/Header.vue'
import PromoteDemoteStudents from '../../components/PromoteDemoteStudents.vue';
import InfoLoader2 from '../../components/InfoLoader2.vue';
import CreateStudentForm from '../../components/parts/CreateStudentForm.vue';
import GetClassesRecordAxiosBySchool from '../../components/parts/GetClassesRecordAxiosBySchool.vue';

  export default {
    name: 'Students',
    components: {
        HeaderVue,
        PromoteDemoteStudents,
        InfoLoader2,
        CreateStudentForm,
        GetClassesRecordAxiosBySchool
    },
    data: () => ({
        authToken:sessionStorage.getItem('authToken') ?? null,
        school:localStorage.getItem('school') ? JSON.parse(localStorage.getItem('school')) : null,
        currentSession:localStorage.getItem('currentSession') ?? null,
        currentTerm:localStorage.getItem('currentTerm') ?? null,
        editFormSignal: false,
        refreshRecordSignal: false,
        activeStudentsCount: null,
        classes:[],
        infos:[

            {content: 'You can now hide students who have left your school by clicking the pencil icon and select status -- inactive'}
        ],
        fetchingContent:true,
        search: '',
        headers: [
          { value: 'passport', text: '', sortable: false  },
          { value: 'fullname', text: 'Student Name' },
          { value: 'student_regno', text: 'Reg/No' },
          { value: 'gender_letter', text: 'Gender' },
          { value: 'current_class', text: 'Class' },
          { value: 'age', text: 'Age' },
          { value: 'status', text: 'Status' },
          { value: 'actions', text: 'Actions', sortable: false },
        ],
        records:[],
    }),
    mounted() {
       if (!this.authToken) {
            this.$router.push({name: 'Login'})
       }
    },
    beforeUpdate() {
        // if (this.classes.length == 0) {
        //     this.$toast.info('You will need to set classes first!', {
        //             timeout: 5000
        //         });
        //     this.$router.push({name: 'Classes'})
        // }
    },
    computed: {
        studentsWithClasses(){
            return this.records.filter(student =>
                this.classes.some(cls => cls.class === student.current_class)
            );
        },
        studentsWithClassesCount(){
            return this.studentsWithClasses.length
        },
    },
    metaInfo: {
        meta: [
            { name: 'viewport', content: 'width=device-width,initial-scale=1.0' }
        ]
    },
    methods: {
        studentClassCount(className) {
            let counter = 0;
            for (const obj of this.records) {
                if (obj.current_class === className && obj.status === 'active') counter++;
            }
            return counter;
        },
        getClasses (data) {
            this.classes = data
        },
        getStudents (data) {
            this.fetchingContent = false
            this.records = data
        },
        getStudentsCount (data){
            this.activeStudentsCount = data
        },
        refreshPromotedStudents(){
            this.refreshRecordSignal = Math.random()
        },
        deleteRecord (record) {
            if(confirm("Do you really want to delete?")){
                let loader = this.$loading.show()
                axios.delete(process.env.VUE_APP_BASEURL+'/students/'+record.student_id+'?school_id='+this.school.school_id+'&confirm=DELETE',{
                    headers:
                    {
                        'Authorization': 'Bearer '+this.authToken
                    }
                })
                .then(response => {
                     this.$toast.success(response.data.message, {
                        timeout: 5000
                    });
                    this.refreshRecordSignal = Math.random()
                })
                .catch(error => {
                    this.$toast.error(error.response ? error.response.data.message : 'Network Error, Please try again few minutes', {
                    timeout: 5000
                    });
                })
                .finally(() => {
                    loader.hide()
                });
            }
        },
        getGenderColor (gender) {
            if (gender == 'Male') return '#D5E0F6'
            else return '#F6C6CB'
        },
    },
  }
</script>

<style scoped>
.search-field {
    max-width: 280px;
}
</style>
